import React from "react";
import { replace } from "redux-little-router";
import { connect } from "react-redux";

export class NotFound extends React.Component {
  componentDidMount() {
    const { onMount = () => {} } = this.props;
    onMount();
  }
  render() {
    return null;
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onMount: () => dispatch(replace("/")),
  };
};
export default connect(null, mapDispatchToProps)(NotFound);



// WEBPACK FOOTER //
// ./src/components/common/NotFound.js